(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2920],{

/***/ 77320:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/android/local/dashboard",
      function () {
        return __webpack_require__(50942);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 19630:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cq": function() { return /* binding */ getCode; },
/* harmony export */   "DF": function() { return /* binding */ androidLocalRefresh; },
/* harmony export */   "LW": function() { return /* binding */ localShooting; },
/* harmony export */   "UC": function() { return /* binding */ localPhoneSendEmailios; },
/* harmony export */   "ds": function() { return /* binding */ CheckCode; },
/* harmony export */   "gM": function() { return /* binding */ checkAppLastVersion; },
/* harmony export */   "lm": function() { return /* binding */ localPhoneSendEmailandroid; },
/* harmony export */   "sk": function() { return /* binding */ setBlock; },
/* harmony export */   "zW": function() { return /* binding */ androidLocalRecordQuestionRrecycleGet; }
/* harmony export */ });
/* unused harmony exports localPhoneSendEmail, androidLocalAsyncDataStatus */
/* harmony import */ var _src_utils_request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93103);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_1__);


//apk注册码
const getCode = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/api/user/get-device-code", options);
//apk验证注册码是否绑定
const CheckCode = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post("/api/user/check-device-code", options);
// 判断本地app是否最新版本
const checkAppLastVersion = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/api/get-app/version?" + qs__WEBPACK_IMPORTED_MODULE_1___default().stringify(options));
// 本地app请求刷新
const androidLocalRefresh = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post("/api/device/android-local-reset-data", options);
// 本地app录制状态获取
const androidLocalRecordQuestionRrecycleGet = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/api/device/android-local-record-question-recycle-get?" + qs__WEBPACK_IMPORTED_MODULE_1___default().stringify(options));
//AndRoid-Local选择moto机型时发送邮件
const localPhoneSendEmail = (options)=>axios.post("/api/definition/target-phone", options);
const localPhoneSendEmailios = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post("/api/definition/target-ios-phone", options);
const localPhoneSendEmailandroid = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post("/api/definition/target-android-phone", options);
//Block app && Block wifi获取应用解锁状态
const setBlock = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post("/api/device/android-local-device-type-limit", options);
//take photos && record video轮训消息
const localShooting = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/api/a-local-shooting-log", {
        params: options
    });
// apk同步下载数据轮询状态
const androidLocalAsyncDataStatus = (options)=>axios.post("/api/device/android-local-async-data-status", options);


/***/ }),

/***/ 74743:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var src_utils_i18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61906);
/* harmony import */ var _ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74249);
/* harmony import */ var _ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3__);




const ContentLoading = (param)=>{
    let { label , fullScreen =false , className =""  } = param;
    const { t  } = (0,src_utils_i18n__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)("common");
    const text = label || t("Loading...");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        role: "status",
        "aria-live": "polite",
        "aria-label": text,
        className: "".concat((_ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3___default().contentLoadingRoot), " ").concat(fullScreen ? (_ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3___default().contentLoadingRootFullScreen) : "", " ").concat(className).trim(),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                src: "/images/loading/spinner.svg",
                alt: "",
                width: 64,
                height: 64,
                className: (_ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3___default().contentLoadingSpinner),
                "aria-hidden": "true",
                priority: true
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: (_ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3___default().contentLoadingLabel),
                children: text
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ContentLoading);


/***/ }),

/***/ 12123:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var src_utils_i18n__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(61906);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9473);
/* harmony import */ var src_store_apps_Common__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(34745);
/* harmony import */ var src_utils_deviceDisconnect__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(22333);









const DisconnectDetection = ()=>{
    const [isShow, setIsShow] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false);
    const store = (0,react_redux__WEBPACK_IMPORTED_MODULE_6__/* .useSelector */ .v9)((state)=>state.Common);
    const selectedDeviceUserId = (0,react_redux__WEBPACK_IMPORTED_MODULE_6__/* .useSelector */ .v9)((state)=>state.Common.deviceUser);
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_6__/* .useDispatch */ .I0)();
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    const { t  } = (0,src_utils_i18n__WEBPACK_IMPORTED_MODULE_5__/* .useTranslation */ .$G)("common");
    const currentMode = store.currentMode || "";
    const shouldMonitor = (0,src_utils_deviceDisconnect__WEBPACK_IMPORTED_MODULE_8__/* .shouldMonitorDeviceDisconnect */ .w5)(router.pathname, currentMode);
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(()=>{
        setIsShow(false);
        const username = JSON.parse(localStorage.getItem("DeviceUser")) != null ? JSON.parse(localStorage.getItem("DeviceUser")).username : "";
        if (!(0,src_utils_deviceDisconnect__WEBPACK_IMPORTED_MODULE_8__/* .shouldMonitorDeviceDisconnect */ .w5)(router.pathname, currentMode) || !username) {
            dispatch((0,src_store_apps_Common__WEBPACK_IMPORTED_MODULE_7__/* .setConnectionStatus */ .bl)(false));
            return;
        }
        dispatch((0,src_store_apps_Common__WEBPACK_IMPORTED_MODULE_7__/* .getConnectionStatus */ .Zp)());
    }, [
        dispatch,
        router.pathname,
        selectedDeviceUserId,
        currentMode
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(()=>{
        if (store && store.isDisconnect) localStorage.setItem("isDisconnect", JSON.stringify(true));
        else localStorage.setItem("isDisconnect", JSON.stringify(false));
    }, [
        store
    ]);
    if (!shouldMonitor) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: store && store.isDisconnect && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "bg-[#FFF] drop-shadow-[0_0_12px_rgba(0,0,0,0.13)] rounded-[10px] pt-[18px] px-[18px] pb-[21px] mb-[20px]",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "w-full flex items-start",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                            src: "/images/common/warning.svg",
                            width: 22,
                            height: 22,
                            alt: "warning"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "ml-[17px]",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    className: "text-[13px] text-[#222222] font-[600] mb-2",
                                    children: t("Childs phone stopped transmitting data")
                                }),
                                !isShow && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "flex items-center cursor-pointer",
                                    onClick: ()=>setIsShow(true),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "text-[13px] text-[#5035FF] font-[600] mr-[5px]",
                                            children: t("See details")
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                            src: "/images/common/drop-down2.svg",
                                            width: 12,
                                            height: 12,
                                            alt: "drop down"
                                        })
                                    ]
                                }),
                                isShow && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "flex items-center cursor-pointer",
                                    onClick: ()=>setIsShow(false),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "text-[13px] text-[#5035FF] font-[600] mr-[5px]",
                                            children: t("Hide details")
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                            src: "/images/common/pull-up2.svg",
                                            width: 12,
                                            height: 12,
                                            alt: "pull-up"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                isShow && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "mt-[18px]",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "w-full bg-[#F5F6F7] rounded-[5px] p-[13px]",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h2", {
                                    className: "text-[18px] text-[#282938] font-[600]",
                                    children: [
                                        t("Why"),
                                        "?"
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "text-[#333333] text-[12px]",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                            className: "text-[13px] mt-[3px] mb-[10px]",
                                            children: [
                                                t("This can happen due to one of the following reasons"),
                                                ":"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "flex mb-[9px]",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "w-[4px] h-[4px] rounded-[50%] bg-[#333333] m-[7px]"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "flex-1",
                                                    children: t("The phone has not been connected to the internet for more than 24 hours")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "flex mb-[9px]",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "w-[4px] h-[4px] rounded-[50%] bg-[#333333] m-[7px]"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "flex-1",
                                                    children: t("The phone was turned off for more than 24 hours")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "flex mb-[9px]",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "w-[4px] h-[4px] rounded-[50%] bg-[#333333] m-[7px]"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "flex-1",
                                                    children: t("Your kid turned on the battery saving mode that stopped Msafely")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "flex",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "w-[4px] h-[4px] rounded-[50%] bg-[#333333] m-[7px]"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "flex-1",
                                                    children: t("Antivirus removed Msafely")
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "w-full bg-[#F5F6F7] rounded-[5px] p-[13px] mt-[10px]",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h2", {
                                    className: "text-[18px] text-[#282938] font-[600] mb-[10px]",
                                    children: [
                                        t("How do I fix this"),
                                        "?"
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "text-[#333333] text-[12px]",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "flex mb-[9px]",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "w-[4px] h-[4px] rounded-[50%] bg-[#333333] m-[7px]"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "flex-1",
                                                    children: t("Make sure the phone is switched on and connected to Wi-Fi or mobile data connection LTE")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "flex mb-[9px]",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "w-[4px] h-[4px] rounded-[50%] bg-[#333333] m-[7px]"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "flex-1",
                                                    children: t("Restart the phone wait for 30 mins then refresh this page")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "flex",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "w-[4px] h-[4px] rounded-[50%] bg-[#333333] m-[7px]"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "flex-1",
                                                    children: [
                                                        t("If this alert is still here it means you have to"),
                                                        " ",
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                                            href: "https://msafely.net/download",
                                                            target: "_blank",
                                                            className: "text-[#2405F2]",
                                                            children: t("re-install Msafely")
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "w-full bg-[#F5F6F7] rounded-[5px] py-[10px] px-[12px] mt-[10px] flex items-center",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                    src: "/images/common/re-install.svg",
                                    width: 50,
                                    height: 50,
                                    alt: "re install"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                    className: "ml-[15px] text-[12px] text-[#333333]",
                                    children: [
                                        t("In case you cant wait for 30 mins"),
                                        " ",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                            href: "https://msafely.net/download",
                                            target: "_blank",
                                            className: "text-[#2405F2]",
                                            children: t("reinstall Msafely right away")
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (DisconnectDetection);


/***/ }),

/***/ 80671:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var src_utils_i18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61906);



const NoData = ()=>{
    var ref, ref1, ref2;
    const { t  } = (0,src_utils_i18n__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)("common");
    const [isDisplay, setIsDisplay] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const email = ((ref = JSON.parse(localStorage.getItem("userData"))) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.email) || "";
    const allDeviceUser = JSON.parse(localStorage.getItem("allDeviceUser")) || [];
    const time = (allDeviceUser === null || allDeviceUser === void 0 ? void 0 : (ref2 = allDeviceUser[0]) === null || ref2 === void 0 ? void 0 : ref2.createdAt) || null;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (!email || !time) return;
        const inputTime = new Date(time).getTime();
        const now = Date.now();
        const oneHourAgo = now - 60 * 60 * 1000;
        const shouldDisplay = inputTime > oneHourAgo;
        setIsDisplay(shouldDisplay);
        localStorage.setItem("isDisplay-".concat(email), JSON.stringify(shouldDisplay));
    }, [
        email,
        time
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (!email) return;
        const stored = localStorage.getItem("isDisplay-".concat(email));
        setIsDisplay(stored === "true");
    }, [
        email
    ]);
    const NoDisplay = ()=>{
        setIsDisplay(false);
        localStorage.setItem("isDisplay-".concat(email), JSON.stringify(false));
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: isDisplay && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "[box-shadow:0px_0px_12px_0px_#00000021] rounded-[10px] bg-white p-5 pt-1 mb-5",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "flex justify-end",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        className: "text-[28px] h-[30px] smjs:translate-y-[20px]",
                        onClick: ()=>NoDisplay(),
                        children: "\xd7"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            src: "/welcome.svg",
                            width: 32,
                            height: 32,
                            alt: "welcome",
                            className: "w-[32px] h-[32px]"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "ml-5 smjs:pr-6",
                            children: t("Welcome We")
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (NoData);


/***/ }),

/***/ 50942:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ local_dashboard; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/utils/i18n.js + 1 modules
var i18n = __webpack_require__(61906);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./node_modules/@mui/material/Card/Card.js + 1 modules
var Card = __webpack_require__(66242);
// EXTERNAL MODULE: ./node_modules/@mui/material/CardContent/CardContent.js + 1 modules
var CardContent = __webpack_require__(44267);
// EXTERNAL MODULE: ./node_modules/antd/es/notification/index.js + 8 modules
var notification = __webpack_require__(16568);
// EXTERNAL MODULE: ./node_modules/antd/es/button/index.js + 10 modules
var es_button = __webpack_require__(75398);
// EXTERNAL MODULE: ./node_modules/antd/es/modal/index.js + 27 modules
var modal = __webpack_require__(60770);
// EXTERNAL MODULE: ./src/@api/dashboard.js
var dashboard = __webpack_require__(95629);
// EXTERNAL MODULE: ./src/@api/android.js
var android = __webpack_require__(19630);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/@api/login.js + 1 modules
var login = __webpack_require__(53399);
// EXTERNAL MODULE: ./src/store/apps/Common/index.js
var Common = __webpack_require__(34745);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/components/FirstBinding/index.js
var FirstBinding = __webpack_require__(80671);
;// CONCATENATED MODULE: ./src/components/PermissionCheck/index.js







const PermissionCheck = ()=>{
    const { t  } = (0,i18n/* useTranslation */.$G)("commonAndroidLocal");
    const [isLoading, setIsLoading] = (0,react.useState)(true);
    const selectedDeviceUserId = (0,es/* useSelector */.v9)((state)=>state.Common.deviceUser);
    const isDisconnectFromStore = (0,es/* useSelector */.v9)((state)=>state.Common.isDisconnect);
    const getStoredUserData = ()=>{
        var ref;
        return (ref = JSON.parse(localStorage.getItem("userData"))) === null || ref === void 0 ? void 0 : ref.data;
    };
    const getStoredDeviceUser = ()=>{
        const saved = localStorage.getItem("DeviceUser");
        return saved ? JSON.parse(saved) : null;
    };
    const deviceUserRef = (0,react.useRef)(getStoredDeviceUser());
    const [isShow, setIsShow] = (0,react.useState)(false) //是否展示提示警告
    ;
    const [showList, setShowList] = (0,react.useState)([]) //未开权限列表
    ;
    const [isSeeMore, setIsSeeMore] = (0,react.useState)(false) //展开显示
    ;
    const [isDisconnect, setIsDisconnect] = (0,react.useState)(true) //设备是否断开连接
    ;
    const PermissionList = [
        {
            name: t("Accessibility"),
            data: "ACCESSIBILITY"
        },
        {
            name: t("Camera"),
            data: "CAMERA"
        },
        {
            name: t("Location"),
            data: "SYSTEM_LOCATION"
        },
        {
            name: t("Location access"),
            data: "LOCATION"
        },
        {
            name: t("SMS"),
            data: "SMS"
        },
        {
            name: t("Call log"),
            data: "CALL_LOG"
        },
        {
            name: t("Photos and videos"),
            data: "PHOTO_LIBRARY"
        },
        {
            name: t("Microphone"),
            data: "MICROPHONE"
        },
        {
            name: t("Contact"),
            data: "CONTACT"
        },
        {
            name: t("Calendar"),
            data: "CALENDAR"
        },
        {
            name: t("Priority"),
            data: "PRIORITY"
        },
        {
            name: t("Screenshot"),
            data: "SCREENSHOT"
        },
        {
            name: t("Notice"),
            data: "NOTICE"
        },
        {
            name: t("Usage data"),
            data: "USAGE_DATA"
        }
    ];
    const getData = async ()=>{
        var ref;
        const username = getStoredUserData();
        const deviceUdid = (ref = deviceUserRef.current) === null || ref === void 0 ? void 0 : ref.username;
        if (!(username === null || username === void 0 ? void 0 : username.email) || !deviceUdid) {
            setIsShow(false);
            setIsLoading(false);
            return;
        }
        setIsLoading(true);
        const result = await (0,dashboard/* getLocalAndroidAll */.gH)({
            username: username.email,
            params: {
                category: "PERMISSION_LIST",
                deviceUdid
            }
        });
        const list = result.data.contents || {};
        const filteredPermissions = PermissionList.filter((item)=>list[item.data] === 0 || !(item.data in list));
        if (filteredPermissions.length > 0) {
            setShowList(filteredPermissions);
            setIsShow(true);
        } else setIsShow(false);
        setIsLoading(false);
    };
    // 设备切换时重新拉权限；断连状态优先读 Redux
    (0,react.useEffect)(()=>{
        deviceUserRef.current = getStoredDeviceUser();
        setIsSeeMore(false);
        setIsDisconnect(isDisconnectFromStore);
        getData();
    }, [
        selectedDeviceUserId,
        isDisconnectFromStore
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: isShow && !isLoading && !isDisconnect && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "bg-[#FFF] drop-shadow-[0_0_12px_rgba(0,0,0,0.13)] rounded-[10px] p-[18px] mb-[20px]",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex items-start",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: "/images/common/warn.svg",
                            width: 22,
                            height: 22,
                            alt: "warning"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "ml-[18px]",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-[13px] text-[#222222] font-[600] mb-2",
                                    children: t("Some permissions are missing")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "text-[12px] text-[#999999] my-1",
                                    children: t("This means Msafely cant update data for certain features")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex items-center cursor-pointer",
                                    onClick: ()=>setIsSeeMore(!isSeeMore),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text-[13px] text-[#5035FF] font-[600] mr-[5px]",
                                            children: isSeeMore ? t("Show less") : t("Show more")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: isSeeMore ? "/images/common/pull-up2.svg" : "/images/common/drop-down2.svg",
                                            width: 12,
                                            height: 12,
                                            alt: "drop down"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                isSeeMore && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mt-[18px] w-full bg-[#F5F6F7] rounded-[6px] p-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-[18px] text-[#282938] font-[600] mb-2",
                            children: t("How do I fix it")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "text-[13px] text-[#333333]",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: t("Youll need to re-enable")
                                }),
                                showList.map((it, i)=>{
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "mt-[6px]",
                                        children: [
                                            "●\xa0\xa0",
                                            it.name
                                        ]
                                    }, i);
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    className: "mt-4",
                                    children: [
                                        t("Go to"),
                                        "\xa0",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/android/local/permission-check",
                                            className: "text-[#5035FF] font-[600]",
                                            onClick: ()=>{},
                                            children: t("Permission Check")
                                        }),
                                        "\xa0",
                                        t("to see the setting paths")
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var components_PermissionCheck = (PermissionCheck);

// EXTERNAL MODULE: ./src/components/Message/index.js + 1 modules
var Message = __webpack_require__(29143);
// EXTERNAL MODULE: ./src/components/ExpirationReminder/index.js
var ExpirationReminder = __webpack_require__(40726);
// EXTERNAL MODULE: ./src/components/DisconnectDetection/index.js
var DisconnectDetection = __webpack_require__(12123);
// EXTERNAL MODULE: ./src/utils/refreshSubscriptionExpire.js
var refreshSubscriptionExpire = __webpack_require__(49354);
// EXTERNAL MODULE: ./src/utils/currentOrder.js
var currentOrder = __webpack_require__(34556);
// EXTERNAL MODULE: ./src/utils/orderLevel.js
var orderLevel = __webpack_require__(23269);
// EXTERNAL MODULE: ./src/components/ContentLoading/index.js
var ContentLoading = __webpack_require__(74743);
// EXTERNAL MODULE: ./src/utils/renewalPlans.js
var renewalPlans = __webpack_require__(22518);
;// CONCATENATED MODULE: ./src/utils/androidLocalFeatureBadgeMap.js
/** USER_SUMMARY.advance 字段 key -> Android Local Feature 名称。 */ const ANDROID_LOCAL_FEATURE_BY_BADGE_FIELD = {
    location: "Locations",
    contact: "Contact",
    sms: "Text Messages",
    app: "Installed Apps",
    video: "Video",
    photo: "Photo",
    call: "Calls",
    wifi: "WI-FI network",
    calendar: "Calendar",
    screenshot_whatsapp: "Whatsapp",
    screenshot_line: "Line",
    screenshot_kik: "Kik",
    screenshot_facebook_messenger: "Messenger",
    screenshot_instagram: "Instagram",
    screenshot_viber: "Viber",
    screenshot_tinder: "Tinder",
    screenshot_skype: "Skype",
    screenshot_youtube: "Youtube",
    screenshot_snapchat: "Snapchat",
    screenshot_telegram: "Telegram",
    screenshot_wechat: "WeChat",
    screenshot_qq: "QQ",
    screenshot_facebook: "Facebook",
    screenshot_teams: "Teams",
    screenshot_tiktok: "TikTok",
    screenshot_discord: "Discord",
    chrome_history: "Browser History",
    screenshot_botim: "Botim",
    screenshot_kakaotalk: "Kakao Talk",
    screenshot_twitter: "Twitter",
    screenshot_gmail: "Gmail",
    screenshot_easilydo_mail: "Easilydo mail",
    key_logger: "Keylogger",
    live_audio: "Record Surround",
    live_screenshot: "Live Screenshot",
    realtime_video_capture: "Record Video",
    live_video: "Record Screen",
    keyword_alerts: "Keyword Alerts",
    monitor_keyword: "Keyword Alerts",
    app_usage: "Screen Time",
    notification: "Notifications",
    realtime_photo_capture: "Take Photos",
    block_applications: "Block Applications",
    block_wifi: "Block Wi-Fi",
    block_website: "Block Website",
    chatgpt: "ChatGPT",
    gemini: "Gemini",
    geofencing: "Geofence"
};
const BADGE_FIELDS_BY_FEATURE = Object.entries(ANDROID_LOCAL_FEATURE_BY_BADGE_FIELD).reduce((fieldsByFeature, param)=>{
    let [field, featureName] = param;
    return {
        ...fieldsByFeature,
        [featureName]: [
            ...fieldsByFeature[featureName] || [],
            field
        ]
    };
}, {});
const applyAdvanceBadgeCount = (feature, advanceData)=>{
    const fields = BADGE_FIELDS_BY_FEATURE[feature.name] || [];
    // Keyword Alerts 优先用 keyword_alerts；旧字段 monitor_keyword 仅作回退，避免重复相加。
    const field = fields.find((key)=>{
        return Number(advanceData === null || advanceData === void 0 ? void 0 : advanceData[key]) > 0;
    }) || fields[0];
    const count = Number(advanceData === null || advanceData === void 0 ? void 0 : advanceData[field]);
    return {
        ...feature,
        num: field && Number.isFinite(count) ? count : 0
    };
};

;// CONCATENATED MODULE: ./src/pages/android/local/dashboard.js





























let allIcon = [
    {
        id: 0,
        name: "Locations",
        img: "/images/dashboard/new-android/gps.svg",
        num: 0,
        href: "/android/local/locations",
        eventName: "Click_GPSlocation"
    },
    {
        id: 1,
        name: "Contact",
        img: "/images/dashboard/new-android/contacts.svg",
        num: 0,
        href: "/android/local/contacts",
        eventName: "Click_Contact"
    },
    {
        id: 2,
        name: "Text Messages",
        img: "/images/dashboard/new-android/message.svg",
        num: 0,
        href: "/android/local/text-messages",
        eventName: "Click_Textmessage"
    },
    {
        id: 3,
        name: "Installed Apps",
        img: "/images/dashboard/new-android/installed.png",
        num: "0",
        href: "/android/local/apps",
        eventName: "Click_Installedapp"
    },
    {
        id: 4,
        name: "Video",
        img: "/images/dashboard/new-android/video.svg",
        num: 0,
        href: "/android/local/videos",
        eventName: "Click_Video"
    },
    {
        id: 5,
        name: "Photo",
        img: "/images/dashboard/new-android/photos.png",
        num: 0,
        href: "/android/local/photos",
        eventName: "Click_Photo"
    },
    {
        id: 6,
        name: "Calls",
        img: "/images/dashboard/new-android/calls.svg",
        num: 0,
        href: "/android/local/calls",
        eventName: "Click_Call"
    },
    {
        id: 7,
        name: "WI-FI network",
        img: "/images/dashboard/new-android/wifi.svg",
        num: 0,
        href: "/android/local/wifi-networks",
        eventName: "Click_Wifinetwork"
    },
    {
        id: 8,
        name: "Calendar",
        img: "/images/dashboard/new-android/calandar.png",
        num: 0,
        href: "/android/local/calendars",
        eventName: "Click_Calendar"
    },
    {
        id: 9,
        name: "Whatsapp",
        img: "/images/dashboard/new-android/whatsapp.svg",
        num: 0,
        href: "/android/local/whatsapp",
        eventName: "Click_WhatsApp"
    },
    {
        id: 10,
        name: "Line",
        img: "/images/dashboard/new-android/line.svg",
        num: 0,
        href: "/android/local/line",
        eventName: "Click_LINE"
    },
    {
        id: 11,
        name: "Kik",
        img: "/images/dashboard/new-android/kik.svg",
        num: 0,
        href: "/android/local/kik",
        eventName: "Click_Kik"
    },
    {
        id: 12,
        name: "Messenger",
        img: "/images/dashboard/new-android/facebookmessage.svg",
        num: 0,
        href: "/android/local/messenger",
        eventName: "Click_Messenger"
    },
    {
        id: 13,
        name: "Instagram",
        img: "/images/dashboard/new-android/instagram.svg",
        num: 0,
        href: "/android/local/instagram",
        eventName: "Click_Instagram"
    },
    {
        id: 14,
        name: "Viber",
        img: "/images/dashboard/new-android/viber.svg",
        num: 0,
        href: "/android/local/viber",
        eventName: "Click_Viber"
    },
    {
        id: 15,
        name: "Tinder",
        img: "/images/dashboard/new-android/tinder.svg",
        num: 0,
        href: "/android/local/tinder",
        eventName: "Click_Tinder"
    },
    {
        id: 16,
        name: "Skype",
        img: "/images/dashboard/new-android/skype.svg",
        num: 0,
        href: "/android/local/skype",
        eventName: "Click_Skype"
    },
    {
        id: 17,
        name: "Youtube",
        img: "/images/dashboard/new-android/youtube.svg",
        num: 0,
        href: "/android/local/youtube",
        eventName: "Click_Youtube"
    },
    {
        id: 18,
        name: "Snapchat",
        img: "/images/dashboard/new-android/snapchat.svg",
        num: 0,
        href: "/android/local/snapchat",
        eventName: "Click_Snapchat"
    },
    {
        id: 19,
        name: "Telegram",
        img: "/images/dashboard/new-android/telegram.svg",
        num: 0,
        href: "/android/local/telegram",
        eventName: "Click_Telegram"
    },
    {
        id: 20,
        name: "WeChat",
        img: "/images/dashboard/new-android/wechat.svg",
        num: 0,
        href: "/android/local/we-chat",
        eventName: "Click_WeChat"
    },
    {
        id: 21,
        name: "QQ",
        img: "/images/dashboard/new-android/qq.svg",
        num: 0,
        href: "/android/local/qq",
        eventName: "Click_QQ"
    },
    {
        id: 22,
        name: "Facebook",
        img: "/images/dashboard/new-android/facebook.svg",
        num: 0,
        href: "/android/local/facebook",
        eventName: "Click_Facebook"
    },
    {
        id: 23,
        name: "Teams",
        img: "/images/dashboard/new-android/teams.svg",
        num: 0,
        href: "/android/local/teams",
        eventName: "Click_Teams"
    },
    {
        id: 24,
        name: "TikTok",
        img: "/images/dashboard/new-android/tiktok.svg",
        num: 0,
        href: "/android/local/tik-tok",
        eventName: "Click_TikTok"
    },
    {
        id: 25,
        name: "Discord",
        img: "/images/dashboard/new-android/discord.svg",
        num: 0,
        href: "/android/local/discord",
        eventName: "Click_Discord"
    },
    {
        id: 26,
        name: "Browser History",
        img: "/images/navigation/chrome.svg",
        num: 0,
        href: "/android/local/browser-history",
        eventName: "Click_Browserhistory"
    },
    {
        id: 27,
        name: "Botim",
        img: "/images/dashboard/new-android/botim.svg",
        num: 0,
        href: "/android/local/botim",
        eventName: "Click_Botim"
    },
    {
        id: 28,
        name: "Kakao Talk",
        img: "/images/dashboard/new-android/kakaotalk.svg",
        num: 0,
        href: "/android/local/kakao-talk",
        eventName: "Click_KakaoTalk"
    },
    {
        id: 29,
        name: "Twitter",
        img: "/images/dashboard/new-android/twitter.svg",
        num: 0,
        href: "/android/local/twitter",
        eventName: "Click_Twitter"
    },
    {
        id: 30,
        name: "Gmail",
        img: "/images/dashboard/new-android/gmail.svg",
        num: 0,
        href: "/android/local/gmail",
        eventName: "Click_Gmail"
    },
    {
        id: 31,
        name: "Easilydo mail",
        img: "/images/dashboard/new-android/easilydo-mail.svg",
        num: 0,
        href: "/android/local/easilydo-mail",
        eventName: "Click_Easilydomail"
    },
    {
        id: 32,
        name: "Keylogger",
        img: "/images/dashboard/new-android/keylogger.svg",
        num: 0,
        href: "/android/local/keylogger",
        eventName: "Click_Keylogger"
    },
    {
        id: 33,
        name: "Record Surround",
        img: "/images/dashboard/new-android/record-surround.svg",
        num: 0,
        href: "/android/local/record-surround",
        eventName: "Click_Recordsurround"
    },
    {
        id: 34,
        name: "Live Screenshot",
        img: "/images/dashboard/new-android/live-screenshot.svg",
        num: 0,
        href: "/android/local/live-screenshot",
        eventName: "Click_Livescreenshot"
    },
    {
        id: 35,
        name: "Record Video",
        img: "/images/dashboard/new-android/record-video.svg",
        num: 0,
        href: "/android/local/record-video",
        eventName: "Click_Recordvideo"
    },
    {
        id: 36,
        name: "ChatGPT",
        img: "/images/dashboard/new-android/chatgpt.svg",
        num: 0,
        href: "/android/local/chatgpt",
        eventName: "Click_ChatGPT",
        noBg: true
    },
    {
        id: 37,
        name: "Gemini",
        img: "/images/dashboard/new-android/gemini.svg",
        num: 0,
        href: "/android/local/gemini",
        eventName: "Click_Gemini",
        noBg: true
    }
];
let otherAppList = [
    {
        id: 0,
        name: "Geofence",
        img: "/images/dashboard/new-android/geo.svg",
        num: 0,
        href: "/android/local/geofence",
        eventName: "Click_Geofence"
    },
    {
        id: 1,
        name: "Keyword Alerts",
        img: "/images/dashboard/new-android/keyword-alerts.svg",
        num: 0,
        href: "/android/local/keyword-alerts",
        eventName: "Click_Keywordalerts"
    },
    {
        id: 2,
        name: "Screen Time",
        img: "/images/dashboard/new-android/screen-time.svg",
        num: 0,
        href: "/android/local/screen-time",
        eventName: "Click_Screentime"
    },
    {
        id: 3,
        name: "Notifications",
        img: "/images/dashboard/new-android/notifications.svg",
        num: 0,
        href: "/android/local/notifications",
        eventName: "Click_Notifications"
    },
    {
        id: 4,
        name: "Record Screen",
        img: "/images/dashboard/new-android/record-screen.svg",
        num: 0,
        href: "/android/local/record-screen",
        eventName: "Click_Recordscreen"
    },
    {
        id: 5,
        name: "Take Photos",
        img: "/images/dashboard/new-android/take-photos.svg",
        num: 0,
        href: "/android/local/take-photos",
        eventName: "Click_Takephotos"
    },
    {
        id: 6,
        name: "Block Applications",
        img: "/images/dashboard/new-android/block-apps.svg",
        num: 0,
        href: "/android/local/block-applications",
        eventName: "Click_Blockapplications"
    },
    {
        id: 7,
        name: "Block Wi-Fi",
        img: "/images/dashboard/new-android/block-wifi.svg",
        num: 0,
        href: "/android/local/block-wifi",
        eventName: "Click_Blockwifi"
    },
    {
        id: 8,
        name: "Block Website",
        img: "/images/dashboard/new-android/block-websites.svg",
        num: 0,
        href: "/android/local/block-website",
        eventName: "Click_Blockwebsite"
    }
];
const Dashboard = ()=>{
    var ref;
    const { t  } = (0,i18n/* useTranslation */.$G)("common");
    const router = (0,next_router.useRouter)();
    const dispatch = (0,es/* useDispatch */.I0)();
    // 异步 Dashboard 拉数归属键，切换设备后旧请求结果会被忽略
    const deviceRequestKey = (0,es/* useSelector */.v9)(Common/* selectDeviceRequestKey */.rx);
    const deviceRequestKeyRef = (0,react.useRef)(deviceRequestKey);
    deviceRequestKeyRef.current = deviceRequestKey;
    let { data: userData  } = JSON.parse(localStorage.getItem("userData"));
    const readDeviceUsername = ()=>{
        var ref;
        return ((ref = JSON.parse(localStorage.getItem("DeviceUser") || "null")) === null || ref === void 0 ? void 0 : ref.username) || "";
    };
    const [api, contextHolder] = notification/* default.useNotification */.ZP.useNotification();
    const [isInviteComment, setIsInviteComment] = (0,react.useState)(false);
    // 提示安装最新app
    const openNotification = (code)=>{
        api.open({
            description: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        style: {
                            marginBottom: "5px"
                        },
                        children: t("The monitoring application you installed is not the latest version. Please go to the link below to download the latest version")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "https://msafely.net/download",
                        style: {
                            textDecoration: "underline",
                            color: "#1677ff"
                        },
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: "https://msafely.net/download"
                    }),
                    code ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        style: {
                            marginTop: "5px"
                        },
                        children: [
                            t("registration code"),
                            ": ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                style: {
                                    color: "#1677ff"
                                },
                                children: code
                            })
                        ]
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            display: "flex",
                            justifyContent: "flex-end",
                            marginTop: "20px"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es_button/* default */.ZP, {
                            onClick: ()=>{
                                localStorage.setItem("reminderLater", new Date().getTime() + 1000 * 60 * 60 * 24 * 7);
                                api.destroy();
                            },
                            children: t("Remind me later")
                        })
                    })
                ]
            }),
            duration: 30
        });
    };
    // 获取是否是最新版本
    const getInstallAppOpen = async (requestKey)=>{
        if (new Date().getTime() < Number(localStorage.getItem("reminderLater"))) return;
        let check = await (0,android/* checkAppLastVersion */.gM)({
            type: "Update service",
            device: readDeviceUsername()
        });
        if (deviceRequestKeyRef.current !== requestKey) return;
        if (check.update) {
            openNotification(check.code);
        }
    };
    (0,react.useEffect)(()=>{
        getInstallAppOpen(deviceRequestKey);
    }, [
        deviceRequestKey
    ]);
    // 数据模块
    const [typeModule, setTypeModule] = (0,react.useState)(allIcon);
    const [otherModule, setOtherModule] = (0,react.useState)(otherAppList);
    const [isLoading, setIsLoading] = (0,react.useState)(true);
    // 克隆列表
    const [cloneList, setCloneList] = (0,react.useState)([]);
    // 与 SpyX 一致：Features 展示完整主列表和其他菜单功能，不限移动端数量。
    (0,react.useEffect)(()=>{
        setCloneList([
            ...typeModule,
            ...otherModule
        ]);
    }, [
        typeModule,
        otherModule
    ]);
    // 数据量最多的常用app列表
    const [frequentlyArr, setFrequentlyArr] = (0,react.useState)([]);
    // 常用功能列表仍保留原有排序逻辑。
    (0,react.useEffect)(()=>{
        if (window.innerWidth < 780 && typeModule && typeModule.length > 0) {
            // 过滤出指定 name 的 icon 并按 num 值降序排序
            let selectedIcons = typeModule.filter((icon)=>{
                return [
                    "Text message",
                    "WhatsApp",
                    "Messenger",
                    "Locations",
                    "Photo",
                    "Video",
                    "Call",
                    "Browser Bookmark",
                    "Snapchat"
                ].includes(icon.name) && icon.num > 0;
            });
            if (selectedIcons.length === 0) {
                return;
            }
            // 过滤出不在 selectedIcons 中的其他 icon 并按 num 值降序排序
            let _selectedIcons = typeModule.filter((icon)=>!([
                    "Text message",
                    "WhatsApp",
                    "Messenger",
                    "Locations",
                    "Photo",
                    "Video",
                    "Call",
                    "Browser Bookmark",
                    "Snapchat"
                ].includes(icon.name) && icon.num > 0)).sort((a, b)=>b.num - a.num);
            localStorage.setItem("frequentlyArr", JSON.stringify([
                ...selectedIcons,
                ..._selectedIcons
            ].sort((a, b)=>b.num - a.num).slice(0, 3)));
            setFrequentlyArr([
                ...selectedIcons,
                ..._selectedIcons
            ].sort((a, b)=>b.num - a.num).slice(0, 3));
        } else {
            localStorage.setItem("frequentlyArr", JSON.stringify([
                ...typeModule
            ].sort((a, b)=>b.num - a.num).slice(0, 3)));
            setFrequentlyArr([
                ...typeModule
            ].sort((a, b)=>b.num - a.num).slice(0, 3));
        }
    }, [
        typeModule
    ]);
    // getData
    const getData = async (requestKey)=>{
        setIsLoading(true);
        try {
            var ref, ref1;
            let contact = await (0,dashboard/* getLocalAndroidAll */.gH)({
                username: userData.email,
                params: {
                    category: "CONTACT",
                    deviceUdid: readDeviceUsername(),
                    offset: 0,
                    limit: 5
                }
            });
            if (deviceRequestKeyRef.current !== requestKey) return;
            if (contact.code === 1002 || contact.data.ec === 40002) {
                setIsLoading(false);
                return;
            }
            let all = await (0,dashboard/* getLocalAndroidAll */.gH)({
                username: userData.email,
                params: {
                    category: "USER_SUMMARY",
                    deviceUdid: readDeviceUsername(),
                    offset: 0,
                    limit: 5
                }
            });
            if (deviceRequestKeyRef.current !== requestKey) return;
            let currentDevice = JSON.parse(localStorage.getItem("currentDevice")) || {
                id: 0
            };
            const summary = (all === null || all === void 0 ? void 0 : (ref = all.data) === null || ref === void 0 ? void 0 : ref.summary) || {};
            let currentAllData;
            if (summary.advance != null) {
                currentAllData = summary.advance.find((row)=>row.device.id == currentDevice.id);
                const _arr = [
                    "screenshot_facebook",
                    "screenshot_facebook_messenger",
                    "screenshot_instagram",
                    "screenshot_kik",
                    "screenshot_line",
                    "screenshot_qq",
                    "screenshot_skype",
                    "screenshot_snapchat",
                    "screenshot_teams",
                    "screenshot_telegram",
                    "screenshot_tiktok",
                    "screenshot_tinder",
                    "screenshot_viber",
                    "screenshot_wechat",
                    "screenshot_whatsapp",
                    "screenshot_youtube"
                ];
                let _isHasData = false;
                for(const key in _arr){
                    if (currentAllData instanceof Array && currentAllData[key]) {
                        _isHasData = true;
                    }
                }
                setIsInviteComment(_isHasData);
            }
            // USER_SUMMARY 的 geofencing 数量在设备 advance 行上（后端按当前设备填充），不在 summary 顶层。
            const currentAdvanceData = currentAllData || ((ref1 = summary.advance) === null || ref1 === void 0 ? void 0 : ref1.find((row)=>{
                var ref;
                return ((ref = row.device) === null || ref === void 0 ? void 0 : ref.id) == currentDevice.id;
            }));
            const featureList = typeModule.map((item)=>applyAdvanceBadgeCount(item, currentAdvanceData));
            setTypeModule(featureList);
            setOtherModule(otherAppList.map((item)=>applyAdvanceBadgeCount(item, currentAdvanceData)));
            localStorage.setItem("userSummary", JSON.stringify(featureList));
        // currentAllData.filter(item => item)
        } finally{
            if (deviceRequestKeyRef.current === requestKey) {
                setIsLoading(false);
            }
        }
    };
    (0,react.useEffect)(()=>{
        setTypeModule(allIcon.map((item)=>({
                ...item
            })));
        getData(deviceRequestKey);
    }, [
        deviceRequestKey
    ]);
    const [orderData, setOrderData] = (0,react.useState)([]);
    const [orderListData, setOrderListData] = (0,react.useState)({});
    // 当前设备的平台类型。必须以【设备接口】user-device 为准：
    // 订单接口 user-account-order 的 platform_type 是「购买的产品」，
    // 不等于当前设备类型（安卓设备的订单也可能是 iOS 产品）。
    const [currentDevicePlatform, setCurrentDevicePlatform] = (0,react.useState)("");
    const [orderIndex, setOrderIndex] = (0,react.useState)(0);
    const [showOrderList, setShowOrderList] = (0,react.useState)(false);
    const [targetDeviceList, setTargetDeviceList] = (0,react.useState)([]);
    const orderListRef = (0,react.useRef)(null);
    const toggleButtonRef = (0,react.useRef)(null) // 绑定按钮引用
    ;
    // 点击按钮显示/隐藏弹窗
    const handleClickOutside = (event)=>{
        // 检查点击的地方是否在按钮或弹窗内
        if (showOrderList && orderListRef.current && !orderListRef.current.contains(event.target) && toggleButtonRef.current && !toggleButtonRef.current.contains(event.target)) {
            setShowOrderList(false);
        }
    };
    const changeOrder = (item, index)=>{
        setOrderListData(item);
        setOrderIndex(index);
        setShowOrderList(false);
    };
    (0,react.useEffect)(()=>{
        document.addEventListener("mousedown", handleClickOutside);
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        showOrderList
    ]) // 依赖于 showOrderList
    ;
    const FirstOrderData = async (requestKey)=>{
        // 设备接口失败不应连累订单卡片，故单独兜底为 null
        const [allDeviceUser, deviceRes] = await Promise.all([
            (0,login.getUserAccountOrder)({
                page: 1,
                pageSize: 9999
            }),
            (0,login.getAllUserDevice)({}).catch(()=>null)
        ]);
        if (deviceRequestKeyRef.current !== requestKey) return;
        // 当前设备类型取【设备接口】user-device，不能用订单接口的 platform_type。
        let storedDeviceUser = {};
        try {
            storedDeviceUser = JSON.parse(localStorage.getItem("DeviceUser") || "{}") || {};
        } catch (e) {
            storedDeviceUser = {};
        }
        const matchedDevice = (0,refreshSubscriptionExpire/* matchCurrentDevice */.pG)(deviceRes === null || deviceRes === void 0 ? void 0 : deviceRes.data, storedDeviceUser);
        setCurrentDevicePlatform((matchedDevice === null || matchedDevice === void 0 ? void 0 : matchedDevice.platform_type) || "");
        let all = allDeviceUser.data;
        // 遍历数组并设置 `name` 属性
        all === null || all === void 0 ? void 0 : all.forEach((item, index)=>{
            item.name = "Acount".concat(String(index + 1).padStart(2, "0"));
        });
        setOrderData(all || []);
        if (all.length > 0) {
            let DeviceUser = null;
            try {
                DeviceUser = JSON.parse(localStorage.getItem("DeviceUser") || "null");
            } catch (e1) {
                DeviceUser = null;
            }
            // 当前设备的关联订单：优先用设备接口的 order_id 直接命中订单主键；
            // 没有 order_id 时按 device_id 找，命中多张则取过期时间最晚的那张（最新的关联单）。
            let lastOrder = DeviceUser ? (0,currentOrder/* resolveDeviceOrder */.mw)({
                orders: all,
                deviceUser: DeviceUser,
                device: matchedDevice
            }) : null;
            // 没有设备上下文（未选中任何设备）时才退回「全局过期最晚的一张」
            if (!lastOrder && !DeviceUser) {
                lastOrder = (0,currentOrder/* pickLatestExpireOrder */.Ft)(all);
            }
            // 卡片展示以【设备接口】为准：user-device 现在直接返回
            // order_id / product_name / order_level / expire_time，就是这台设备当前的订阅状态；
            // 订单只用于补设备接口没有的字段（如 merchant_no → 注册码行）。
            setOrderListData((0,currentOrder/* resolveCardSubscription */.Xm)({
                order: lastOrder,
                device: matchedDevice
            }));
        }
    };
    // 获取设备信息
    const getDeviceList = async (requestKey)=>{
        const get = await (0,dashboard/* getLocalAndroidAll */.gH)({
            username: userData.email,
            params: {
                category: "DEVICE_LIST",
                offset: 0,
                limit: 100
            }
        });
        if (deviceRequestKeyRef.current !== requestKey) return;
        if (get.data.contents) setTargetDeviceList(get.data.contents);
    };
    (0,react.useEffect)(()=>{
        FirstOrderData(deviceRequestKey);
        getDeviceList(deviceRequestKey);
    }, [
        deviceRequestKey
    ]);
    // 延长续订
    const [extendSubscriptionModal, setExtendSubscriptionModal] = (0,react.useState)(false);
    const extendSubscription = async ()=>{
        const renewId = await (0,renewalPlans/* fetchRenewProductIdForOrder */.R4)(orderListData);
        if (!renewId) {
            window.dispatchEvent(new Event("renewalFailed"));
            (0,Message/* messageInfo */.B)({
                content: t("Payment failed"),
                duration: 6
            });
            setExtendSubscriptionModal(false);
            return;
        }
        let result = await (0,dashboard/* extendSubscriptionTime */.rK)({
            merchant_no: orderListData.merchant_no,
            renewId,
            order_type: 274
        });
        if (Number(result.code) === 0) {
            (0,Message/* messageInfo */.B)({
                content: "".concat(result.msg),
                duration: 1.5
            });
            setExtendSubscriptionModal(false);
            // 与 iOS dashboard / ExpiredPurchaseGuide 一致：整页刷新，避免过期 banner/遮罩残留
            (0,refreshSubscriptionExpire/* reloadAfterRenewSuccess */.dZ)();
            return;
        }
        window.dispatchEvent(new Event("renewalFailed"));
        (0,Message/* messageInfo */.B)({
            content: "".concat(result.msg),
            duration: 6
        });
        setExtendSubscriptionModal(false);
    };
    const openNav = ()=>{
        dispatch((0,Common/* toggleNavVisibility */.m_)(true));
    };
    (0,react.useEffect)(()=>{
        dispatch((0,Common/* setCurrentTab */.Lw)(t("Dashboard")));
        return ()=>dispatch((0,Common/* setCurrentTab */.Lw)(""));
    }, [
        dispatch,
        t
    ]);
    // 埋点上报
    (0,react.useEffect)(()=>{}, []);
    const [favoriteArr, setFavoriteArr] = (0,react.useState)([]);
    const menuCacheRef = (0,react.useRef)({}) // { [device_id]: menuList }
    ;
    // 初始化收藏菜单功能数组
    (0,react.useEffect)(()=>{
        const requestKey = deviceRequestKey;
        const init = async function() {
            let forceRefresh = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
            if (!(typeModule === null || typeModule === void 0 ? void 0 : typeModule.length)) return;
            const deviceUser = localStorage.getItem("DeviceUser");
            const device_id = deviceUser ? JSON.parse(deviceUser).device_id : "";
            if (!device_id) return;
            // 用完整列表映射，避免 cloneList 在移动端被 slice(0,9) 后丢收藏项
            const typeModuleMap = new Map(typeModule.map((item)=>[
                    (item.href || item.url).toLowerCase(),
                    item
                ]));
            const otherAppListMap = new Map(otherAppList.map((item)=>[
                    (item.href || item.url).toLowerCase(),
                    item
                ]));
            // 使用缓存，除非 forceRefresh 为 true
            let menuList = menuCacheRef.current[device_id];
            if (!menuList || forceRefresh) {
                menuList = await (0,dashboard/* getMenuFavorite */.mz)(device_id);
                if (deviceRequestKeyRef.current !== requestKey) return;
                menuCacheRef.current[device_id] = menuList;
            }
            // 初始化默认菜单
            const hasInit = localStorage.getItem("menuFavoriteInit-".concat(device_id));
            if (!hasInit && (!(menuList === null || menuList === void 0 ? void 0 : menuList.data) || menuList.data.length === 0)) {
                localStorage.setItem("menuFavoriteInit-".concat(device_id), "true");
                await Promise.all([
                    (0,dashboard/* postMenuFavorite */.fR)({
                        device_id: device_id,
                        name: "Text message",
                        url: "/android/local/text-messages",
                        status: true
                    }),
                    (0,dashboard/* postMenuFavorite */.fR)({
                        device_id: device_id,
                        name: "WhatsApp",
                        url: "/android/local/whatsapp",
                        status: true
                    }),
                    (0,dashboard/* postMenuFavorite */.fR)({
                        device_id: device_id,
                        name: "Facebook",
                        url: "/android/local/facebook",
                        status: true
                    }),
                    (0,dashboard/* postMenuFavorite */.fR)({
                        device_id: device_id,
                        name: "Instagram",
                        url: "/android/local/instagram",
                        status: true
                    })
                ]);
                if (deviceRequestKeyRef.current !== requestKey) return;
                // 再次拉取数据，重试保证接口有数据
                let retry = 3;
                while(retry > 0){
                    menuList = await (0,dashboard/* getMenuFavorite */.mz)(device_id);
                    if (deviceRequestKeyRef.current !== requestKey) return;
                    if ((menuList === null || menuList === void 0 ? void 0 : menuList.data) && menuList.data.length > 0) break;
                    await new Promise((resolve)=>setTimeout(resolve, 100));
                    retry--;
                }
                menuCacheRef.current[device_id] = menuList;
            }
            // 构造 favoriteArr
            const result = ((menuList === null || menuList === void 0 ? void 0 : menuList.data) || []).map((item)=>typeModuleMap.get(item.url.toLowerCase()) || otherAppListMap.get(item.url.toLowerCase())).filter(Boolean);
            if (deviceRequestKeyRef.current !== requestKey) return;
            setFavoriteArr(result);
        };
        init();
        const handler = ()=>init(true) // 强制刷新
        ;
        window.addEventListener("menuUpdated", handler);
        return ()=>{
            window.removeEventListener("menuUpdated", handler);
        };
    }, [
        typeModule,
        deviceRequestKey
    ]);
    // 卡片上判断「是不是 iOS / 安卓」一律用设备类型（设备接口），
    // 订单类型只作为设备类型取不到时的兜底，避免改变原有表现。
    const cardPlatformType = currentDevicePlatform || (orderListData === null || orderListData === void 0 ? void 0 : orderListData.platform_type) || "";
    const selectedTargetDeviceId = readDeviceUsername();
    let selectedTargetDevice = targetDeviceList.find((item)=>{
        return String((item === null || item === void 0 ? void 0 : item.id) || "") === String(selectedTargetDeviceId);
    });
    if (!selectedTargetDevice) {
        try {
            const currentDevice = JSON.parse(localStorage.getItem("currentDevice") || "null");
            if (String((currentDevice === null || currentDevice === void 0 ? void 0 : currentDevice.id) || "") === String(selectedTargetDeviceId)) {
                selectedTargetDevice = currentDevice;
            }
        } catch (e) {
            selectedTargetDevice = null;
        }
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        style: {
            userSelect: "none"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpirationReminder/* default */.Z, {
                orders: orderData
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DisconnectDetection/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_PermissionCheck, {}, deviceRequestKey || "none"),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative min-h-[calc(var(--vh2)*100-90px)]",
                children: [
                    isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute inset-0 z-[20] bg-[#FFF] rounded-[10px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentLoading/* default */.Z, {})
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        container: true,
                        spacing: 6,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                            item: true,
                            xs: 12,
                            md: 12,
                            lg: 12,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
                                    style: {
                                        width: "100%",
                                        marginBottom: "20px"
                                    },
                                    className: "".concat(favoriteArr.length === 0 && "hidden"),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "w-full flex justify-between items-center mb-[10px] px-[18px] pt-4",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                className: "text-[18px] text-[#222] font-[600]",
                                                children: t("Favorites")
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent/* default */.Z, {
                                            style: {
                                                display: "flex",
                                                flexWrap: "wrap"
                                            },
                                            children: favoriteArr.map((row)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                                    item: true,
                                                    xs: 4,
                                                    md: 3,
                                                    lg: 2,
                                                    style: {
                                                        position: "relative",
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        alignItems: "center",
                                                        marginBottom: "10px"
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                                                        className: "flex flex-col items-center justify-center",
                                                        href: row.href,
                                                        onClick: ()=>{},
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "w-[50px] h-[50px] relative",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                        src: row.img,
                                                                        alt: "img",
                                                                        width: 50,
                                                                        height: 50,
                                                                        className: "mx-auto relative rounded-[14px] ".concat(row.noBg ? "" : "p-2 bg-[#F0F1F5]")
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: "absolute left-[38px] top-[-8px] min-w-[20px] h-[20px] p-[3px] bg-[#EB4D3D] text-[14px] text-[#FFF] rounded-[10px] flex justify-center items-center",
                                                                        children: row.num
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "text-[12px] Blds:text-[14px] text-[#2E2E2E] mt-[6px] h-[48px] w-full text-center",
                                                                style: {
                                                                    textAlign: "center"
                                                                },
                                                                children: t(row.name)
                                                            })
                                                        ]
                                                    })
                                                }, row.id))
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
                                    style: {
                                        width: "100%"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "w-full flex justify-between items-center mb-[10px] px-[18px] pt-4",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                    className: "text-[18px] text-[#222] font-[600] Bxls:hidden",
                                                    children: t("Hot features")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                    className: "text-[18px] text-[#222] font-[600] hidden Bxls:block",
                                                    children: t("Features")
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: " border-0 px-[10px] h-[30px] rounded-[22.5px] hover:bg-[#454CFF] text-[#454CFF] hover:text-[#FFF] text-[12px] Bxls:hidden flex items-center font-[600]",
                                                    onClick: openNav,
                                                    children: t("SEE ALL")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent/* default */.Z, {
                                            style: {
                                                display: "flex",
                                                flexWrap: "wrap"
                                            },
                                            children: cloneList.map((row)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                                    item: true,
                                                    xs: 4,
                                                    md: 3,
                                                    lg: 2,
                                                    style: {
                                                        position: "relative",
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        alignItems: "center",
                                                        marginBottom: "10px"
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                                                        className: "flex flex-col items-center justify-center",
                                                        href: row.href,
                                                        onClick: ()=>{},
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "w-[50px] h-[50px] relative",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                        src: row.img,
                                                                        alt: "img",
                                                                        width: 50,
                                                                        height: 50,
                                                                        className: "mx-auto relative rounded-[14px] ".concat(row.noBg ? "" : "p-2 bg-[#F0F1F5]")
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: "absolute left-[38px] top-[-8px] min-w-[20px] h-[20px] p-[3px] bg-[#EB4D3D] text-[14px] text-[#FFF] rounded-[10px] flex justify-center items-center",
                                                                        children: row.num
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "text-[12px] Blds:text-[14px] text-[#2E2E2E] mt-[6px] h-[48px] w-full text-center",
                                                                style: {
                                                                    textAlign: "center"
                                                                },
                                                                children: t(row.name)
                                                            })
                                                        ]
                                                    })
                                                }, row.id))
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "grid grid-cols-3 Hsm:grid-cols-2 Hsm:Dsm:grid-cols-1 w-full gap-[20px] mt-[20px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "bg-[#FFF] drop-shadow-[0_0_12px_rgba(0,0,0,0.13)] rounded-[10px] pt-[18px] px-[18px] pb-[30px]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex justify-between items-center relative",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                className: "text-[18px] text-[#222] font-[600]",
                                                children: t("Account")
                                            }),
                                            showOrderList && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                ref: orderListRef,
                                                className: "bg-[#FFF] w-full absolute left-0 top-[40px] z-10 rounded-[8px] p-[8px] drop-shadow-[0_4px_8px_rgba(0,0,0,0.13)] overflow-auto",
                                                children: orderData.map((row, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        onClick: ()=>changeOrder(row, index),
                                                        className: "hover:bg-[#F4F5F6] hover:cursor-pointer px-[15px] py-[10px] ".concat(orderIndex === index ? "bg-[#F4F5F6]" : ""),
                                                        children: row.name
                                                    }, index))
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "w-full h-[1px] bg-[#E5E5E5] my-[20px]"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "w-full h-auto flex flex-col justify-between text-[14px]",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "w-full flex justify-between items-center h-[36px]",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "text-[#334062]",
                                                        children: [
                                                            t("Product"),
                                                            ":"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "text-[#9198AD]",
                                                        children: cardPlatformType
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "w-full flex justify-between items-center h-[36px]",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "text-[#334062]",
                                                        children: [
                                                            t("Subscription Plan"),
                                                            ":"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "text-[#9198AD]",
                                                        children: [
                                                            cardPlatformType === "iOS-Cloud" && ((0,orderLevel/* isBasicOrderLevel */.$w)(orderListData === null || orderListData === void 0 ? void 0 : orderListData.order_level) ? "".concat(t("Basic"), " - ") : "Extreme - "),
                                                            orderListData === null || orderListData === void 0 ? void 0 : orderListData.product_name
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "w-full flex justify-between items-center h-[36px]",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "text-[#334062]",
                                                        children: [
                                                            t("Expiry Date"),
                                                            ":"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "text-[#9198AD]",
                                                        children: dayjs_min_default()(orderListData.expire_time).format("YYYY-MM-DD")
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "w-full flex justify-between items-center h-[36px] ".concat(cardPlatformType.includes("Android") && new Date(orderListData === null || orderListData === void 0 ? void 0 : orderListData.expire_time) > new Date() ? "block" : "hidden"),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "text-[#334062]",
                                                        children: [
                                                            t("Registration Code"),
                                                            ":"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "text-[#9198AD]",
                                                        children: orderListData === null || orderListData === void 0 ? void 0 : (ref = orderListData.merchant_no) === null || ref === void 0 ? void 0 : ref.slice(-8)
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: "text-[#454CFF] w-full h-[45px] border border-[#454CFF] rounded-[22.5px] mt-[36px] hover:bg-[#454CFF] hover:text-[#FFF]",
                                        onClick: ()=>setExtendSubscriptionModal(true),
                                        children: t("Extend subscription")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "bg-[#FFF] drop-shadow-[0_0_12px_rgba(0,0,0,0.13)] rounded-[10px] pt-[18px] px-[18px] pb-[24px] w-full aspect-square self-start overflow-hidden flex flex-col",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        className: "text-[18px] text-[#222] font-[600] mb-[20px]",
                                        children: t("Target Device Info")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "w-full h-[54px] bg-[#F4F5F6] rounded-[8px] pl-[8px] pr-[14px] relative flex items-center text-[#334062] text-[16px]",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "ml-[10px]",
                                            children: (selectedTargetDevice === null || selectedTargetDevice === void 0 ? void 0 : selectedTargetDevice.name) || ""
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "w-full h-[108px] mt-[24px] flex flex-col justify-between",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "w-full flex justify-between items-center text-[14px]",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "text-[#334062]",
                                                        children: "IMEI:"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "text-[#9198AD]",
                                                        children: selectedTargetDevice === null || selectedTargetDevice === void 0 ? void 0 : selectedTargetDevice.serial_number
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "w-full flex justify-between items-center text-[14px]",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "text-[#334062]",
                                                        children: "Version:"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "text-[#9198AD]",
                                                        children: selectedTargetDevice === null || selectedTargetDevice === void 0 ? void 0 : selectedTargetDevice.version
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "w-full flex justify-between items-center text-[14px]",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "text-[#334062]",
                                                        children: "Model:"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "text-[#9198AD]",
                                                        children: selectedTargetDevice === null || selectedTargetDevice === void 0 ? void 0 : selectedTargetDevice.model
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal/* default */.Z, {
                open: extendSubscriptionModal,
                onCancel: ()=>setExtendSubscriptionModal(false),
                footer: [],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        style: {
                            marginTop: "10px",
                            fontWeight: "600"
                        },
                        children: t("After confirmation a new order will be produced to extend the equipment expiration time")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        style: {
                            display: "flex",
                            justifyContent: "center",
                            marginTop: "14px"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es_button/* default */.ZP, {
                                onClick: ()=>extendSubscription(),
                                style: {
                                    marginRight: "10px"
                                },
                                children: t("Confirm")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(es_button/* default */.ZP, {
                                onClick: ()=>setExtendSubscriptionModal(false),
                                children: t("Cancel")
                            })
                        ]
                    })
                ]
            }),
            contextHolder
        ]
    });
};
/* harmony default export */ var local_dashboard = (Dashboard);


/***/ }),

/***/ 22333:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "fb": function() { return /* binding */ usesLayoutDisconnectDetection; },
/* harmony export */   "w5": function() { return /* binding */ shouldMonitorDeviceDisconnect; }
/* harmony export */ });
/* unused harmony export DASHBOARD_PATHS_WITH_CUSTOM_DISCONNECT */
/** Dashboard 页面自行放置 DisconnectDetection，Layout 层不再渲染 */ const DASHBOARD_PATHS_WITH_CUSTOM_DISCONNECT = [
    "/dashboard",
    "/android/dashboard",
    "/android/local/dashboard"
];
/**
 * 当前路径是否使用 Layout 层断连检测（自定义 Dashboard 页返回 false）。
 * @param {string} pathname - Next.js router.pathname
 * @returns {boolean}
 */ const usesLayoutDisconnectDetection = (pathname)=>!DASHBOARD_PATHS_WITH_CUSTOM_DISCONNECT.includes(pathname);
/**
 * 是否应对当前页面启用 Android Local 断连轮询。
 * @param {string} pathname
 * @param {string} currentMode - Redux Common.currentMode
 * @returns {boolean}
 */ const shouldMonitorDeviceDisconnect = (pathname, currentMode)=>currentMode === "Android-Local" && pathname === "/android/local/dashboard";


/***/ }),

/***/ 23269:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$w": function() { return /* binding */ isBasicOrderLevel; }
/* harmony export */ });
/* unused harmony export resolveOrderLevel */
/**
 * 订单等级（订阅档位）归一化。
 *
 * 后端 order_level 的取值：
 *   1 = 初级（Basic）
 *   2 = 高级（Extreme）
 *
 * 历史遗留：增值服务（初级 / 高级分档）上线之前，老用户买的产品包**没有分档**，
 * 这些订单的 order_level 为 null（少数情况下是字符串 'null'）。按业务约定，
 * 这类订单一律**视为 2（高级）**。
 *
 * 因此本函数只在**明确等于 1** 时返回 1，其余（null / 'null' / undefined /
 * 其他非法值）一律返回 2。
 *
 * 之所以显式归一化，而不是直接用 `Number(order_level) === 1`：
 * 后者虽然对 null 也"碰巧"得到 Extreme（Number(null) === 0），但那只是巧合，
 * 一旦有人把判断改成 `=== 2 ? 'Extreme' : 'Basic'` 就会把老用户错判成初级。
 *
 * @param {*} orderLevel - 订单接口返回的 order_level
 * @returns {1|2} 归一化后的档位
 */ const resolveOrderLevel = (orderLevel)=>Number(orderLevel) === 1 ? 1 : 2;
/**
 * 是否为初级（Basic）档位。
 * 历史老用户（order_level 为 null）按高级处理，这里返回 false。
 *
 * @param {*} orderLevel - 订单接口返回的 order_level
 * @returns {boolean}
 */ const isBasicOrderLevel = (orderLevel)=>resolveOrderLevel(orderLevel) === 1;
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (resolveOrderLevel)));


/***/ }),

/***/ 49354:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Af": function() { return /* binding */ refreshSubscriptionExpire; },
/* harmony export */   "Vk": function() { return /* binding */ RENEW_SUCCESS_REFRESH_DELAY; },
/* harmony export */   "dZ": function() { return /* binding */ reloadAfterRenewSuccess; },
/* harmony export */   "pG": function() { return /* binding */ matchCurrentDevice; }
/* harmony export */ });
/* harmony import */ var src_api_login__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53399);
/* harmony import */ var src_store_apps_Common__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34745);


const readDeviceUser = ()=>{
    try {
        return JSON.parse(localStorage.getItem("DeviceUser") || "{}") || {};
    } catch (e) {
        return {};
    }
};
/**
 * 在设备列表里定位当前设备（先按 device_id，再按 iCloud_username）。
 * 供「需要按设备接口判定平台类型」的页面复用。
 * @param {Array} list - user-device 接口返回的设备数组
 * @param {Object} deviceUser - localStorage DeviceUser 对象
 * @returns {Object|null}
 */ const matchCurrentDevice = (list, deviceUser)=>{
    const devices = Array.isArray(list) ? list : [];
    const deviceId = deviceUser === null || deviceUser === void 0 ? void 0 : deviceUser.device_id;
    const username = deviceUser === null || deviceUser === void 0 ? void 0 : deviceUser.username;
    if (deviceId != null && deviceId !== "") {
        const byId = devices.find((item)=>String(item.id) === String(deviceId) || String(item.device_id) === String(deviceId));
        if (byId) return byId;
    }
    if (username) {
        return devices.find((item)=>item.iCloud_username === username) || null;
    }
    return null;
};
/**
 * 续费 / 升级成功后无感刷新：
 * 1. 重拉设备列表写入 allDeviceUser
 * 2. 同步当前 DeviceUser.expire_time
 * 3. bump deviceSwitchRevision，驱动侧栏 / ExpiredMask 重算
 *
 * @param {Object} [params]
 * @param {import('redux').Dispatch} [params.dispatch]
 * @param {string} [params.expireTime] - 接口已返回的新到期时间，优先写入
 * @returns {Promise<{ ok: boolean, expireTime: string|null, device: Object|null }>}
 */ const refreshSubscriptionExpire = async function() {
    let { dispatch , expireTime  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (false) {}
    const prevDeviceUser = readDeviceUser();
    let devices = [];
    try {
        const res = await (0,src_api_login__WEBPACK_IMPORTED_MODULE_0__.getAllUserDevice)({});
        devices = Array.isArray(res === null || res === void 0 ? void 0 : res.data) ? res.data : [];
        localStorage.setItem("allDeviceUser", JSON.stringify(devices));
    } catch (e) {
        ;
    }
    const matched = matchCurrentDevice(devices, prevDeviceUser);
    const nextExpire = expireTime || (matched === null || matched === void 0 ? void 0 : matched.expire_time) || (prevDeviceUser === null || prevDeviceUser === void 0 ? void 0 : prevDeviceUser.expire_time) || null;
    var _iCloud_username, _temporary, _order_id, ref, ref1, _subscription_status, ref2;
    const nextDeviceUser = {
        ...prevDeviceUser,
        ...matched ? {
            username: (_iCloud_username = matched.iCloud_username) !== null && _iCloud_username !== void 0 ? _iCloud_username : prevDeviceUser.username,
            temporary: (_temporary = matched.temporary) !== null && _temporary !== void 0 ? _temporary : prevDeviceUser.temporary,
            device_id: matched.id || matched.device_id || prevDeviceUser.device_id || "",
            order_id: (ref1 = (ref = (_order_id = matched.order_id) !== null && _order_id !== void 0 ? _order_id : matched.orderId) !== null && ref !== void 0 ? ref : prevDeviceUser.order_id) !== null && ref1 !== void 0 ? ref1 : null,
            subscription_status: (ref2 = (_subscription_status = matched.subscription_status) !== null && _subscription_status !== void 0 ? _subscription_status : prevDeviceUser.subscription_status) !== null && ref2 !== void 0 ? ref2 : null
        } : {},
        ...nextExpire ? {
            expire_time: nextExpire
        } : {}
    };
    localStorage.setItem("DeviceUser", JSON.stringify(nextDeviceUser));
    if (typeof dispatch === "function") {
        dispatch((0,src_store_apps_Common__WEBPACK_IMPORTED_MODULE_1__/* .subscriptionRefreshed */ .Hw)());
    }
    return {
        ok: true,
        expireTime: nextExpire,
        device: matched
    };
};
/** 站内直接续费成功后延时整页刷新；软同步覆盖不全（banner / 遮罩仍可能停在已过期） */ const RENEW_SUCCESS_REFRESH_DELAY = 1500;
const reloadAfterRenewSuccess = function() {
    let delay = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : RENEW_SUCCESS_REFRESH_DELAY;
    if (false) {}
    window.setTimeout(()=>window.location.reload(), delay);
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (refreshSubscriptionExpire)));


/***/ }),

/***/ 96613:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EI": function() { return /* binding */ parseExpireMs; },
/* harmony export */   "Jn": function() { return /* binding */ THIRTY_DAYS_MS; },
/* harmony export */   "ku": function() { return /* binding */ resolveDeviceExpireTime; },
/* harmony export */   "l": function() { return /* binding */ buildDeviceUserPayload; }
/* harmony export */ });
/* unused harmony exports isSubscriptionActive, isDeviceActive, isExpiredPastGracePeriod, areAllDevicesExpiredPastGrace, isDeviceWithinGracePeriod, shouldShowExpiredMask, pickFirstActiveDevice */
/**
 * 解析 expire_time 为 UTC 毫秒时间戳。
 * ISO 8601 带 Z（如 2026-11-16T07:35:07.623Z）会被正确解析为绝对时刻，与用户本地时区无关。
 */ const parseExpireMs = (raw)=>{
    if (raw == null || raw === "") return NaN;
    const ms = new Date(raw).getTime();
    return Number.isFinite(ms) ? ms : NaN;
};
/** 订阅仍有效：无 expire_time 视为有效；否则 expire_time >= 当前时刻 */ const isSubscriptionActive = function(expireTime) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now();
    const ms = parseExpireMs(expireTime);
    if (!Number.isFinite(ms)) return true;
    return ms >= now;
};
const isDeviceActive = (device)=>{
    return isSubscriptionActive(device === null || device === void 0 ? void 0 : device.expire_time);
};
const THIRTY_DAYS_MS = 30 * 24 * 60 * 60 * 1000;
/** 已过期且超过宽限期（默认 30 天） */ const isExpiredPastGracePeriod = function(expireTime) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now(), graceMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : THIRTY_DAYS_MS;
    const ms = parseExpireMs(expireTime);
    if (!Number.isFinite(ms)) return false;
    if (ms >= now) return false;
    return now - ms > graceMs;
};
/** 全部设备均已过期且超过宽限期 */ const areAllDevicesExpiredPastGrace = function(devices) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now(), graceMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : THIRTY_DAYS_MS;
    const list = Array.isArray(devices) ? devices : [];
    if (!list.length) return false;
    return list.every((device)=>{
        return isExpiredPastGracePeriod(device === null || device === void 0 ? void 0 : device.expire_time, now, graceMs);
    });
};
/** 从侧栏设备项（数组或单条记录）解析 expire_time */ const resolveDeviceExpireTime = (item)=>{
    var ref, ref1, ref2;
    if (!item) return null;
    if (item.expire_time != null && item.expire_time !== "") return item.expire_time;
    if (Array.isArray(item) && ((ref = item[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.DeviceUser) === null || ref1 === void 0 ? void 0 : ref1.expire_time)) return item[0].DeviceUser.expire_time;
    if (item === null || item === void 0 ? void 0 : (ref2 = item.DeviceUser) === null || ref2 === void 0 ? void 0 : ref2.expire_time) return item.DeviceUser.expire_time;
    return null;
};
/** 侧栏仍展示：未过期、无 expire_time、或过期未超过 graceDays（默认 30 天） */ const isDeviceWithinGracePeriod = function(expireTime) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now(), graceMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : THIRTY_DAYS_MS;
    const ms = parseExpireMs(expireTime);
    if (!Number.isFinite(ms)) return true;
    if (ms >= now) return true;
    return now - ms <= graceMs;
};
/** Feature 详情页遮罩：已过期且在宽限期内（默认 30 天） */ const shouldShowExpiredMask = function(expireTime) {
    let now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now(), graceMs = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : THIRTY_DAYS_MS;
    return !isSubscriptionActive(expireTime, now) && isDeviceWithinGracePeriod(expireTime, now, graceMs);
};
/** 取第一个可选中设备：优先未过期(active)，其次宽限期(grace)；永不返回超 30 天失效 */ const pickFirstActiveDevice = (devices, platformType)=>{
    const list = Array.isArray(devices) ? devices : [];
    const scoped = platformType ? list.filter((item)=>{
        return (item === null || item === void 0 ? void 0 : item.platform_type) === platformType;
    }) : list;
    const now = Date.now();
    const selectable = scoped.filter((item)=>{
        const ms = parseExpireMs(item === null || item === void 0 ? void 0 : item.expire_time);
        if (!Number.isFinite(ms)) return true;
        if (ms >= now) return true;
        return now - ms <= THIRTY_DAYS_MS;
    });
    if (!selectable.length) return null;
    return selectable.find(isDeviceActive) || selectable[0] || null;
};
var ref, ref1, ref2;
const buildDeviceUserPayload = (device)=>{
    return {
        username: device.iCloud_username,
        password: device.iCloud_password,
        temporary: device.temporary,
        expire_time: device.expire_time,
        likeType: device.like_type,
        device_id: (device === null || device === void 0 ? void 0 : device.id) || (device === null || device === void 0 ? void 0 : device.device_id) || "",
        order_id: (ref1 = (ref = device === null || device === void 0 ? void 0 : device.order_id) !== null && ref !== void 0 ? ref : device === null || device === void 0 ? void 0 : device.orderId) !== null && ref1 !== void 0 ? ref1 : null,
        subscription_status: (ref2 = device === null || device === void 0 ? void 0 : device.subscription_status) !== null && ref2 !== void 0 ? ref2 : null
    };
};


/***/ }),

/***/ 74249:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"contentLoadingRoot":"ContentLoading_contentLoadingRoot__ypzGH","contentLoadingRootFullScreen":"ContentLoading_contentLoadingRootFullScreen__ZmB8e","contentLoadingSpinner":"ContentLoading_contentLoadingSpinner__4vCxU","content-loading-spin":"ContentLoading_content-loading-spin__K0YUP","contentLoadingLabel":"ContentLoading_contentLoadingLabel__S0w79"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3498,5675,5432,9830,5170,2862,770,1664,6886,9166,530,726,9774,2888,179], function() { return __webpack_exec__(77320); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);